// @flow
import { useRef, useCallback } from 'react';
import { isFunction } from 'lodash';

export default (ref) => {
  const layoutRef = useRef();

  const setLayoutRef = useCallback(
    (layout) => {
      if (ref) {
        if (isFunction(ref)) {
          ref(layout);
        } else {
          ref.current = layout;
        }
      }

      layoutRef.current = layout;
    },
    [ref]
  );

  return {
    layout: layoutRef.current,
    setLayoutRef,
  };
};
